/**
 * Revisione pagamenti 2026-07-22 — pill "DA INCASSARE €X".
 *
 * Presentazionale unico riusato da: RoomTile (size sm), RoomDetailPanel /
 * RoomDetailDrawer (Row dedicata), CheckoutModal (banner in alto), lista
 * prenotazioni. Palette rossa coerente col design system (stessi hex della
 * pill stato camera "Guasta" in dashboard-v2/lib.ts: #FBEEEC / #A8453A).
 */
import { cn } from '@hotel-manager/ui/lib/cn';
import { pendingPaidAnomalyLabel, unpaidLabel } from '../lib/paymentStatus.js';

export function UnpaidBadge({
  amount,
  size = 'md',
  className,
}: {
  /** Residuo in euro (usa unpaidAmount(booking)). Se <= 0 non renderizza. */
  amount: number;
  /** 'sm' = pill compatta per tile camera; 'md' = pill standard. */
  size?: 'sm' | 'md';
  className?: string;
}) {
  if (amount <= 0) return null;
  return (
    <span
      data-testid="unpaid-badge"
      className={cn(
        'inline-flex items-center rounded font-bold uppercase whitespace-nowrap',
        'bg-[#FBEEEC] text-[#A8453A] border border-[#E7C1BB]',
        size === 'sm'
          ? 'text-[8px] tracking-[0.2px] px-1 py-px'
          : 'text-[11px] tracking-[0.4px] px-2 py-0.5',
        className,
      )}
    >
      {unpaidLabel(amount)}
    </span>
  );
}

/**
 * ONDATA 2 P2a — pill arancione 'ANOMALIA PAGAMENTO' per i pending pagati
 * (isPendingPaidAnomaly). Palette arancio del design system (#FFF3E6 /
 * #C4661F, stessi hex dei tab attivi in prenotazioni).
 */
export function PaymentAnomalyBadge({ className }: { className?: string }) {
  return (
    <span
      data-testid="payment-anomaly-badge"
      className={cn(
        'inline-flex items-center rounded font-bold uppercase whitespace-nowrap',
        'bg-[#FFF3E6] text-[#C4661F] border border-[#E9C9A6]',
        'text-[11px] tracking-[0.4px] px-2 py-0.5',
        className,
      )}
    >
      {pendingPaidAnomalyLabel()}
    </span>
  );
}
